import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-template',
  templateUrl: './loading-template.component.html',
  styleUrls: ['./loading-template.component.scss']
})
export class LoadingTemplateComponent implements OnInit {

  constructor() { }
  @Input() minusMargin = false;
  ngOnInit() {
  }
  getMargin() {
    if(this.minusMargin) return { 'margin-top' : '-182px'};
    else return null;
  }
}
